import { useEffect, useState } from 'react'
import { useParams } from 'react-router'

import { fetchOrder } from 'utils/api'
import PaymentDetailsComponent from 'components/PaymentDetailsComponent'
import { isEmpty } from 'lodash'

const PaymentDetails = () => {
  const [paymentTransactions, setPaymentTransactions] = useState([])
  const { uuid, transactionHistoryId } = useParams()

  useEffect(() => {
    fetchOrder(uuid).then((res) =>
      setPaymentTransactions(
        // filter payment transactions and return this payment which match with transactionHistoryId in order to
        // display this payment details
        res?.data?.paymentTransactions?.filter((transaction) => {
          return transaction?.id === Number(transactionHistoryId)
        })
      )
    )
  }, [uuid, transactionHistoryId])

  return (
    <PaymentDetailsComponent
      paymentTransactions={paymentTransactions}
      isLoading={isEmpty(paymentTransactions)}
    />
  )
}

export default PaymentDetails
